import { baseQuery } from '../baseQuery';

type PerformanceStats = {
  totalCalls: number;
  avgCallDuration: number;
  loginTime: number;
  totalJobs: number;
  sameDayJobs: number;
};

export const getUserPerformanceStats = async () => {
  const { data } = await baseQuery('user-stats');

  return data as PerformanceStats;
};
